export const getContentStyle = () => ({
  display: 'flex',
  justifyContent: 'center',
  backgroundColor: '#F5F4F2',
  padding: '24px 0',
});

export const getDiscoverContentStyle = () => ({
  backgroundColor: '#E3D3A9',
  padding: '12px 0px 4px 0px',
});

export const getDiscoverContentMainDiv = () => ({ minWidth: 1200, backgroundColor: '#F5F4F2' });
